import { render, staticRenderFns } from "./Screenshotsd.vue?vue&type=template&id=5d3229b6&"
import script from "./Screenshotsd.vue?vue&type=script&lang=js&"
export * from "./Screenshotsd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports